module.exports = __webpack_public_path__ + "static/media/page-not-found.28ebf8ad.svg";